import { headerBgGradient1 } from './HeaderBgStore';

import { headerBgGradient1Default } from './HeaderBgStoreDefaults';

export const resetHeaderBgGradient1 = () => headerBgGradient1.set(headerBgGradient1Default);
